import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { shouldFetchAuthenticatedBootstrapApis } from "@/lib/authBootstrapGate";
import { ensureReady } from "../i18n/i18nLoader";

export const useTranslationLoader = () => {
  const { i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const loadTranslations = useCallback(
    async (language?: string) => {
      if (!shouldFetchAuthenticatedBootstrapApis()) {
        setIsLoaded(true);
        setIsLoading(false);
        return;
      }

      const targetLanguage = language ?? i18n.language;
      setIsLoading(true);
      try {
        await ensureReady({ lng: targetLanguage, nsList: ["common"] });
        setIsLoaded(true);
      } catch (error) {
        console.error("Failed to load translations:", error);
        setIsLoaded(false);
      } finally {
        setIsLoading(false);
      }
    },
    [i18n.language]
  );

  useEffect(() => {
    loadTranslations();
  }, [loadTranslations]);

  useEffect(() => {
    if (isLoaded) {
      loadTranslations();
    }
  }, [i18n.language, isLoaded, loadTranslations]);

  return {
    isLoading,
    isLoaded,
    loadTranslations,
    currentLanguage: i18n.language,
  };
};
